module.exports = __webpack_public_path__ + "assets/img/dcb45b980b2223df53a06b24e0a6629f.png";